<template>
  <div>
    <Slick ref="slick" class="api-carousel" :options="slickOptions" @afterChange="afterChange">
      <div v-if="isPartnerCard">
        <InfoCard
          gaId="ga-CC05-2-01"
          :to="{ type: 'link', link: getEditableInfo('user_guide', 'invite-developers-to-partner-api-as-providers') }"
          title="CC05-2-02"
          description="CC05-2-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
      <div v-for="(item, index) in items" :key="`before-main-${index}-${Date.now()}`">
        <ApiCardBranded
          :item="item"
          :clickHandler="apiCardClickHandler"
          :fromApiCarousel="true"
          :fromProvider="fromProvider"
          :useCase="useCase"
          :afterLogin="afterLogin"
          :carouselId="carouselId"
          :loading="loading"
        />
      </div>
      <div v-if="isPartnerCard">
        <InfoCard
          :to="{ type: 'link', link: getEditableInfo('user_guide', 'why-cant-i-see-my-partners-api') }"
          title="CC05-3-02"
          description="CC05-3-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
      <div v-else-if="isUploadedCard">
        <InfoCard
          :to="{ type: 'link', link: `${DEVELOPER_PORTAL_URL}/${FABRIX_CLIENT_ID}/#/be-a-provider` }"
          title="CC05-7-02"
          description="CC05-7-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
      <div v-else-if="!fromProvider || isSubscribedCard">
        <InfoCard
          :to="{ type: 'router', name: 'api-catalogue', params: { category: 'all' } }"
          title="CC05-4-02"
          description="CC05-4-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
      <div v-if="isSubscribedCard">
        <InfoCard
          :to="{ ...getEditableInfo('new_idea_api_card', 'action', false) }"
          title="CC05-5-02"
          description="CC05-5-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
      <div v-else-if="isUploadedCard">
        <InfoCard
          :to="{ ...getEditableInfo('provider_leads_card', 'action', false) }"
          title="CC05-6-02"
          description="CC05-6-03"
          :showDeveloperInfo="true"
          :withDeveloperInfo="loggedIn && userProfile.id !== ''"
        />
      </div>
    </Slick>
  </div>
</template>

<script>
import ApiCardBranded from './api-card-branded'
import InfoCard from './info-card'
import Slick from 'vue-slick'
const $ = require('jquery')
import DummyApiCardData from '@/data/api-card-dummy-data'
import getRuntimeConfig from '../utils/get-runtime-config'
import getEditableInfo from '@/utils/get-editable-info'
import { FABRIX_CLIENT_ID } from '@/constants'

export default {
  name: 'ApiCarousel',
  components: {
    Slick,
    ApiCardBranded,
    InfoCard
  },
  props: {
    carouselId: {
      type: String,
      default: 'carousel'
    },
    items: {
      type: Array,
      default: () => []
    },
    apiCardClickHandler: {
      type: Function,
      default: () => {}
    },
    useCase: {
      type: Boolean,
      default: false
    },
    fromProvider: {
      type: Boolean,
      default: false
    },
    isPartnerCard: {
      type: Boolean,
      default: false
    },
    isSubscribedCard: {
      type: Boolean,
      default: false
    },
    isUploadedCard: {
      type: Boolean,
      default: false
    },
    afterLogin: {
      type: String,
      default: 'apiReadmeBranded'
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      DEVELOPER_PORTAL_URL: '',
      FABRIX_CLIENT_ID: FABRIX_CLIENT_ID,
      slickOptions: {
        // infinite: false,
        initialSlide: 0,
        // useTransform: false,
        // transformAnimate: false,
        dots: false,
        dotsClass: 'api-carousel-dots',
        slidesToShow: 4,
        adaptiveHeight: true,
        prevArrow: `<span class="fa fa-arrow-left slick-arrow slick-arrow-primary-white slick-arrow-left slick-arrow-centered-y shadow-soft rounded-circle ml-n3" />`,
        nextArrow: `<span class="fa fa-arrow-right slick-arrow slick-arrow-primary-white slick-arrow-right slick-arrow-centered-y shadow-soft rounded-circle mr-n3" />`,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              dots: false
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              dots: this.carouselId !== 'before-login-api-carousel-trending'
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              dots: this.carouselId !== 'before-login-api-carousel-trending'
            }
          }
        ]
      }
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    },
    loggedIn() {
      return this.$store.getters.login
    },
    beforeItems() {
      if (this.loading) {
        return this.isPartnerCard ? [DummyApiCardData, DummyApiCardData, DummyApiCardData] : [DummyApiCardData, DummyApiCardData, DummyApiCardData, DummyApiCardData]
      } else {
        return this.isPartnerCard ? (this.items.length >= 3 ? this.items.slice(0, 3) : this.items) : this.items
      }
    },
    afterItems() {
      return this.isPartnerCard ? (this.items.length >= 3 ? this.items.slice(3, 9) : []) : []
    },
    staticCardNum() {
      return this.isPartnerCard ? 2 : 1
    },
    calcCardNum() {
      return this.isPartnerCard ? this.staticCardNum + 1 : this.staticCardNum
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {}
    }
  },
  async created() {
    const runtimeConfig = await getRuntimeConfig()
    this.DEVELOPER_PORTAL_URL = runtimeConfig.DEVELOPER_PORTAL_URL
  },
  beforeUpdate() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy()
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions)
        //  We will simulate a click event for cloned API cards.
        $(document).find('.api-carousel .slick-cloned').on('click', e => {
          //  clickIndex returns their index computed by slick - but they are not always in a properly defined range.
          //  So we will get the raw index, then use modulo to find the properly defined index.
          const clickIndex = $(e.currentTarget).data('slickIndex')
          if (this.isPartnerCard && (clickIndex === this.items.length + this.staticCardNum)) {
            const link = this.getEditableInfo('user_guide', 'invite-developers-to-partner-api-as-providers')
            window.open(link, '_blank')
          } else {
            const itemIndex = (clickIndex % this.items.length + this.items.length) % this.items.length - this.calcCardNum
            this.apiCardClickHandler(this.items[itemIndex])
          }
        })
      }
    })
  },
  methods: {
    afterChange() {
      this.$nextTick(function() {
        if (this.$refs.slick) {
          //  We will simulate a click event for cloned API cards.
          $(document).find('.api-carousel .slick-cloned').on('click', e => {
            //  clickIndex returns their index computed by slick - but they are not always in a properly defined range.
            //  So we will get the raw index, then use modulo to find the properly defined index.
            const clickIndex = $(e.currentTarget).data('slickIndex')
            if (this.isPartnerCard && (clickIndex === this.items.length + this.staticCardNum)) {
              const link = this.getEditableInfo('user_guide', 'invite-developers-to-partner-api-as-providers')
              window.open(link, '_blank')
            } else {
              const itemIndex = (clickIndex % this.items.length + this.items.length) % this.items.length - this.calcCardNum
              this.apiCardClickHandler(this.items[itemIndex])
            }
          })
        }
      })
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale.toLowerCase() : '')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~slick-carousel/slick/slick.css';
@import '~slick-carousel/slick/slick-theme.css';
.api-carousel {
  width: 100%;
}
.api-card-cta {
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}
.avatar {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  .avatar-img {
    width: 100%;
    height: 100%;
  }
}
</style>
